"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RoubleCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RoubleCircleLinear = function RoubleCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#RoubleCircleLinear_svg__RoubleCircleLinear_svg__paint0_linear_17373_95645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.936 37.793h-6.738V44h-2.234v-6.207H19.23V35.87h3.735v-2.728H19.23v-1.905h3.735V17.34h9.082c2.808 0 4.999.714 6.574 2.142 1.587 1.416 2.38 3.345 2.38 5.786 0 2.49-.769 4.425-2.307 5.805-1.538 1.367-3.735 2.057-6.592 2.069h-6.903v2.728h6.738v1.923zm-6.738-6.555h6.848c2.124 0 3.772-.513 4.944-1.538 1.172-1.038 1.758-2.503 1.758-4.395 0-1.831-.574-3.284-1.721-4.358-1.136-1.074-2.704-1.636-4.706-1.684h-7.123v11.974z",
    fill: "url(#RoubleCircleLinear_svg__RoubleCircleLinear_svg__paint1_linear_17373_95645)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "RoubleCircleLinear_svg__RoubleCircleLinear_svg__paint0_linear_17373_95645",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "RoubleCircleLinear_svg__RoubleCircleLinear_svg__paint1_linear_17373_95645",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.RoubleCircleLinear = RoubleCircleLinear;
var _default = RoubleCircleLinear;
exports.default = _default;